module Steps.FormPreview where

import Common

import API.FormType (formQuery)
import Concur.React.DOM as D
import Concur.React.Props as P
import Effect.Class.Console as Console
import Error (ErrorContext(..), handleCritical)
import GraphQL.Type (typedId)
import Widgets.Form (formWidget, fromFormType)
import Widgets.Form.Class (FormWidgetResult(..), blankFormContext)

previewWidget :: Int -> Widget HTML Unit
previewWidget id = do
    -- Notify that we have successfully entered the preview widget
    liftEffect $ Console.log  $ "Previewing form: " <> show id

    -- Get FormType from API
    form <- affAction $ formQuery $ typedId $ show id

    parseForm form
    where
        formContext = blankFormContext

        displayFormWidget ft = do
            newft <-
                D.div
                    [ P.className "step-container" ]
                    [ D.div
                        [ P.className "step-preview" ]
                        [ ignoreAction <$> formWidget formContext ft ]
                    ]
            displayFormWidget newft

        ignoreAction (FormWidgetResult { state }) = state

        parseForm (Left err) = handleCritical
            $ WithContext (InModule "Steps.FormPreview.previewWidget")
            $ WithContext (DuringAction "parsing FormType from API")
            err
        parseForm (Right formtype) =
            displayFormWidget $ fromFormType formtype
